<template>
  <div class="chapter-btn">
    <button
      class="next-level-btn"
      @click="goNextLesson"
      v-if="page == 'main' && nextLesson.length"
    >
      {{ $t("chapter.chanper-btn.continue") }}
    </button>
    <!-- <button
      class="next-level-btn"
      :disabled="!savedWords"
      v-if="page == 'savedwords'"
      @click="playSaved"
    >
      שחק
    </button> -->
    <!-- <button class="next-level-btn on" @click="navigateToCourseByType()">
      חומרי לימוד
    </button> -->
  </div>
</template>

<script>
import "./chapter-btn.scss";

export default {
  name: "chapter-btn",
  props: ["nextLesson", "page", "user"],
  data() {
    return {
      chapter: null
    };
  },
  created() {},
  computed: {
    savedWords() {
      if (this.user) {
        return this.user.saved_words.length;
      } else {
        return 0;
      }
    }
  },
  methods: {
    goNextLesson() {
      if (this.nextLesson && this.nextLesson.id) {
        this.$router.push("/lesson/" + this.nextLesson.id);
      }
    },
    navigateToCourseByType() {
      const chapter = this.$route.params.id;
      this.$router.push("/chapter/" + chapter + "?sort=gametype");
    },
    playSaved() {
      console.log("playing saved words");
      this.$router.push("/game/savedwords");
    }
  },
  watch: {
    user() {
      this.savedWords = this.user.saved_words.length
    }
  },
  components: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// chapter-btn.vue?5962cd06